<template>
  <nav class="navbar navbar-fixed-top" role="navigation">
    <div class="container">
      <div class="navbar-header">
        <router-link
          class="navbar-brand brand-logo"
          to="/"
          @click.native="scrollToTop"
        >Hu-Nora Family Cabin</router-link>
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <div class="navbar-collapse collapse">
        <ul class="nav navbar-nav navbar-right">
          <li>
            <router-link to="/" @click.native="scrollToTop">Home</router-link>
          </li>
          <li>
            <a href="#availability">Availability</a>
          </li>
          <li>
            <a href="#area">Area And Location</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    methods: {
      scrollToTop() {
        window.scrollTo(0, 0);
      }
    }
  };
</script>
